"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _v = _interopRequireDefault(require("uuid/v4"));

var _oxygenConstants = require("@8x8/oxygen-constants");

var _oxygenUtils = require("@8x8/oxygen-utils");

var _pubsubJs = _interopRequireDefault(require("pubsub-js"));

var _lodash = _interopRequireDefault(require("lodash.isundefined"));

var _config = require("./config");

var events = _interopRequireWildcard(require("./constants/events"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Toast DTO
 */
var Toast = /*#__PURE__*/function () {
  /**
   * @param {Node|String} content
   * @param {Array} [actions=[]]
   * @param {Boolean} [hideCloseControl=false]
   * @param {String} [type=toastTypes.success]
   * @param {Number} duration
   * @param {String} size
   */
  function Toast(content) {
    var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var hideCloseControl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _oxygenConstants.toastTypes.success;
    var duration = arguments.length > 4 ? arguments[4] : undefined;
    var size = arguments.length > 5 ? arguments[5] : undefined;

    _classCallCheck(this, Toast);

    this.id = undefined;
    this.content = undefined;
    this.actions = [];
    this.hideCloseControl = undefined;
    this.type = undefined;
    this.duration = undefined;
    this.size = undefined;
    this.expirationTimeout = undefined;
    this.id = (0, _v["default"])();
    this.content = content;
    this.actions = actions.map(function (action) {
      return Object.assign({}, action, {
        id: (0, _v["default"])()
      });
    });
    this.hideCloseControl = hideCloseControl;
    this.type = type;
    this.duration = (0, _lodash["default"])(duration) ? (0, _config.getConfig)().duration : duration;
    this.size = size;
    this.initExpirationTimeout(this.duration);
  }

  _createClass(Toast, [{
    key: "close",
    value: function close() {
      _pubsubJs["default"].publish(events.REMOVE_TOAST, this.id);

      if (this.expirationTimeout) {
        this.expirationTimeout.clear();
      }
    }
  }, {
    key: "initExpirationTimeout",
    value: function initExpirationTimeout(duration) {
      var _this = this;

      if (duration === Infinity) {
        return;
      }

      this.expirationTimeout = new _oxygenUtils.PausableTimeout(function () {
        return _this.close();
      }, duration);
    }
  }, {
    key: "pauseExpirationTimeout",
    value: function pauseExpirationTimeout() {
      if (this.expirationTimeout) {
        this.expirationTimeout.pause();
      }
    }
  }, {
    key: "resumeExpirationTimeout",
    value: function resumeExpirationTimeout() {
      if (this.expirationTimeout) {
        this.expirationTimeout.resume();
      }
    }
  }]);

  return Toast;
}();

var _default = Toast;
exports["default"] = _default;